import styled from "styled-components";

const List = styled.ul`
  margin: 0;
  padding-left: 2rem;
  margin-bottom: 20px;
`;

export default List;
